import styles from "@/styles/checkout-layout.module.scss"
import { useEffect } from "react"
import Link from 'next/link'
import { Image } from "antd"

import { loadMatomo } from "@/utils/matomo"
import { loadGtm } from "@/utils/gtm"
import { loadForter } from "@/utils/forter";

import loginApi from '@/service/modules/loginApi';

import getConfig from 'next/config'
const { publicRuntimeConfig } = getConfig()
const imageDomain = publicRuntimeConfig.imageDomain
import { useRouter } from 'next/router';
import { abTestCalculate } from "@/utils/ABtest"
import GoogleAnalytics from "./GoogleAnalytics"
import { setCookie } from "@/utils/cookie"
const apiDomain = publicRuntimeConfig.apiDomain;
interface LayoutProps {
  children: React.ReactNode;
}

export default function DefaultLayout(props: LayoutProps) {
  const currentYear = new Date().getFullYear(); // 获取当前年份

  // 请求me接口，这里需要登录（另外可以续命session）
  const renewalLoginStatus = async () => {
    try {
      const res = await loginApi.me()
      console.log(res, ' == user info');
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    // 加载AB测试逻辑
    abTestCalculate("2025-07-16_ABTest_Swiper")
  }, [])

  useEffect(() => {
    // 创建字体链接
    const loadFonts = () => {
      const fontLink = document.createElement('link');
      fontLink.rel = 'stylesheet';
      fontLink.href = 'https://fonts.googleapis.com/css?family=Rubik:300,400,500,700,900&display=swap';
      
      // 添加预连接优化
      const preconnectLink = document.createElement('link');
      preconnectLink.rel = 'preconnect';
      preconnectLink.href = 'https://fonts.gstatic.com';
      preconnectLink.crossOrigin = 'anonymous';
      
      document.head.appendChild(preconnectLink);
      document.head.appendChild(fontLink);
    };

    // 动态创建广告脚本
    const loadAdScript = () => {
      const adsbygoogleScript = document.createElement('script');
      adsbygoogleScript.async = true;
      adsbygoogleScript.src = "//pagead2.googlesyndication.com/pagead/js/adsbygoogle.js";
      document.body.appendChild(adsbygoogleScript);
    };

    // 动态创建Criteo脚本
    const loadCriteoScript = () => {
      const criteoScript = document.createElement('script');
      criteoScript.async = true;
      criteoScript.src = "https://static.criteo.net/js/ld/ld.js";
      document.body.appendChild(criteoScript);
    };

    function handleWindowLoad() {
      setTimeout(() => {
        renewalLoginStatus();
      }, 2000);

      loadFonts();
      loadAdScript();
      loadCriteoScript();
      loadMatomo()
      loadForter();
      // dataLayer数据需要先异步等待加载完成再执行，设置先不加载的白名单URL
      const whitelistPattern = /^(\/view-cart|\/payment-captrue|\/checkout\/b-pay|\/online)/;
      if (!whitelistPattern.test(window.location.pathname)) {
        loadGtm(); // 如果不匹配，则加载 GTM
      }
    }

    window.addEventListener('load', handleWindowLoad);

    return () => {
      window.removeEventListener('load', handleWindowLoad);
    };
  }, []);

  const router = useRouter()

  useEffect(() => {
    const { aid, recoveraid }: any = router.query
    let lastAidValue = ''
    let lastRecoveraidValue = ''

    // 检查是否有"aid"参数，如有多个取最后
    if (Array.isArray(aid) && aid.length > 0) {
      lastAidValue = aid[aid.length - 1]
    } else if (typeof aid === 'string') {
      // 如果只有一个"aid"参数，它将是一个字符串
      lastAidValue = aid
    }

    // 检查是否有"recoveraid"参数，如有多个取最后
    if (Array.isArray(recoveraid) && recoveraid.length > 0) {
      lastRecoveraidValue = recoveraid[recoveraid.length - 1]
    } else if (typeof recoveraid === 'string') {
      // 如果只有一个"recoveraid"参数，它将是一个字符串
      lastRecoveraidValue = recoveraid
    }

    // 优先于异步请求，将aid存入cookie, 60秒过期（后续会发起请求重新设置）
    if (lastAidValue || lastRecoveraidValue) {
      let currentDomain = window.location.hostname;
      if (currentDomain == 'www.crazysales.com.au') {
        currentDomain = ".crazysales.com.au"
      }
      setCookie('affiliateid', lastAidValue || lastRecoveraidValue, { expires: 30, secure: true, domain: `${currentDomain}`, })
    }

  }, [router.query])

  return (
    <div className={styles['checkout-layout']}>
      <GoogleAnalytics />
      <div className={styles['header-box']}>
        <div className={styles['header']}>
          <div className={styles['left']}>
            <Link
              href={`/`}
              legacyBehavior
            >
              <a rel="noopener noreferrer">
                <Image src={`${imageDomain}/checkout/logo.svg`} width={203} preview={false} />
              </a>
            </Link>
          </div>
          <div className={styles['right']}>
            <Image src={`${imageDomain}/checkout/norton.png`} preview={false} className={styles['norton']} />
            <Image src={`${imageDomain}/checkout/compdp.png`} preview={false} className={styles['compdp']} />
          </div>
        </div>
      </div>

      <main className={styles['checkout-layout-container']}>
        {props.children}
      </main>

      <div className={styles['footer-box']}>
        Copyright &copy; 2007 - {currentYear} Crazy Sales. All rights reserved.ABN 66 166 623 169 | PO BOX 1016 Springvale, VIC 3171, Australia
      </div>
    </div>
  )
}